import AppHeaderNoauth from "@/components/AppHeaderNoauth";

export default {
  name: "first-login",
  components: {
    AppHeaderNoauth
  },
  created() {},
  data() {
    return {
      password: "",
      password_verification: "",
      errorInfo: ""
    };
  },
  methods: {
    async changePassword() {
      let data = {
        user_id: localStorage.user_id,
        password: this.password
      };
      let res = await this.$store
        .dispatch("CHANGE_PASSWORD", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push("/");
      }
    },
    passwordVerify() {
      if (
        this.password &&
        this.password_verification &&
        this.password != this.password_verification
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
